import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { checkAndRefreshToken } from 'utils/authUtils';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const faqApi = createApi({
  reducerPath: 'faq',

  
  baseQuery: createBaseQueryWithReauth(''),
  tagTypes: ['Faq'],

  endpoints: builder => ({
    getFaq: builder.query({
      query: () => ({
        url: `/faq`,
        method: 'GET',
      }),
      providesTags: ['Faq'],
    }),

    createFaq: builder.mutation({
      query: data => ({
        url: '/merchant-feedbacks/create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Faq'],
    }),

  }),
});

export const {
  useGetFaqQuery,
  useCreateFaqMutation
} = faqApi;
